import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isFetched: false,
  jobTitles: [],
  cities: [],
  provinces: [],
  jobFields: [],
};

const candidatesDataSlice = createSlice({
  name: "candidatesData",
  initialState,
  reducers: {
    setCandidatesData: (state, action) => {
      return { isFetched: true, ...action.payload };
    },
  },
});

export const { setCandidatesData } = candidatesDataSlice.actions;
export default candidatesDataSlice.reducer;
